import React, { useState, useEffect } from "react";
import axios from "../../services/api";

const MaintenanceList = () => {
  const [maintenanceRecords, setMaintenanceRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMaintenanceRecords();
  }, []);

  const fetchMaintenanceRecords = async () => {
    try {
      const response = await axios.get("/api/maintenance");
      setMaintenanceRecords(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching maintenance records:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this maintenance record?")) {
      try {
        await axios.delete(`/api/maintenance/${id}`);
        fetchMaintenanceRecords(); // Refresh list after deletion
      } catch (error) {
        console.error("Error deleting maintenance record:", error);
      }
    }
  };

  return (
    <div className="container">
      <h2>Maintenance Records</h2>
      {loading ? (
        <p>Loading maintenance records...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Item</th>
              <th>Maintenance Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {maintenanceRecords.map((record) => (
              <tr key={record.id}>
                <td>{record.id}</td>
                <td>{record.item_name}</td>
                <td>{new Date(record.maintenance_date).toLocaleDateString()}</td>
                <td>{record.status}</td>
                <td>
                  <button onClick={() => handleDelete(record.id)} className="btn btn-danger">
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MaintenanceList;
